<div
  class="container"
  [class.grid]="grid"
>
  <app-checkbox-button
    *ngFor="let item of items"
    [ngClass]="'item ' + size "
    [label]="item.label"
    [name]="item.name"
    [checked]="item.selected"
    (itemChanged)="itemChange($event , item)"
    [disabled]="disabled"
  >
  </app-checkbox-button>
</div>
